import { useMatchesCalendarStore } from '../store';

export const useMatchesCalendarMode = () => {
  const mode = useMatchesCalendarStore((state) => state.mode);
  const setMode = useMatchesCalendarStore((state) => state.setMode);

  return { mode, setMode };
};
